import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { ReportService } from "../report.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import * as moment from "moment";

@Component({
	selector: "app-ms-facility-time",
	templateUrl: "./ms-facility-time.component.html",
	styleUrls: ["./ms-facility-time.component.css"],
})
export class MsFacilityTimeComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		FacilityID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		VisitorTypeID: 0,
		VisitorStatusID: 0,
		SortBy: "TotalTime",
		SortDirection: "DESC",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	FacilityList: any = [];
	VisitorTypeList: any = [];
	VisitorStatusList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "TotalTime",
			Desc: "Time Spent at Facility",
		},
		{
			ID: "VisitCount",
			Desc: "Number of Visits",
		},
		{
			ID: "ScanCount",
			Desc: "Number of Scans",
		},
	];

	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 449;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.loadVisitorTypeList();
		this.loadVisitorStatusList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadFacilityList();
		this.loadLogolist();
	}

	private loadVisitorTypeList() {
		var result = this.reportService.MsVisitorTypeSelectList();
		result.subscribe(
			(response) => {
				this.VisitorTypeList = response;

				this.VisitorTypeList.unshift({
					VisitorTypeID: -1,
					VisitorTypeDesc: "Any",
				});

				this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
			},
			(error) => {}
		);
	}

	private loadVisitorStatusList() {
		var result = this.reportService.MsVisitorStatusSelectList();
		result.subscribe(
			(response) => {
				this.VisitorStatusList = response;

				this.VisitorStatusList.unshift({
					VisitorStatusID: -1,
					VisitorStatusDesc: "Any",
				});

				this.report.VisitorStatusID = this.VisitorStatusList[0].VisitorStatusID;
			},
			(error) => {}
		);
	}

	private loadFacilityList() {
		var result = this.reportService.FacilitySelectList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				this.report.FacilityID = this.FacilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (this.report.FacilityID == undefined || this.report.FacilityID <= 0) {
			this.errorMessage = "Select a facility";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 449;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: FacilityID
		strParam += "," + this.report.FacilityID + "|FacilityID";

		//Parameter 3: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 4: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 5: VisitorTypeID
		strParam += "," + this.report.VisitorTypeID + "|VisitorTypeID";

		//Parameter 6: VisitorStatusID
		strParam += "," + this.report.VisitorStatusID + "|VisitorStatusID";

		//Parameter 7: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 8: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 9: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
